<div class="section">
  <h3>{{ 'shopping_cart.quickorder.forgotsomething.title' | translate }}</h3>
  <form [formGroup]="directOrderForm" (ngSubmit)="onSubmit()" data-testing-id="direct-order-form">
    <div class="row mb-1 justify-content-center forgot-input">
      <div class="col-6">
        <formly-form [form]="directOrderForm" [fields]="fields" [model]="model" />
      </div>
      <div class="col-3 p-0">
        <ish-product-quantity />
      </div>
      <div class="col-3">
        <button
          type="submit"
          class="forget-something-cart btn btn-primary"
          [disabled]="
            directOrderForm.pristine ||
            this.directOrderForm.invalid ||
            (hasQuantityError$ | async) ||
            (loading$ | async)
          "
        >
          <!-- {{ 'quickorder.page.add.cart' | translate }} -->
          <fa-icon [icon]="['fas', 'shopping-cart']" />
        </button>
      </div>
    </div>
  </form>
</div>
